import React from 'react'
import moment from 'moment'
import { hasData, Gtm } from 'helpers'
import { Loader, ScrollerSelect, SearchContainer, VarietiesTable } from 'components'
import { ArticleTypes } from 'types'
import { API, STORAGE_KEYS, PAGE_TYPES } from 'src/constants'

interface Props {
    articles: ArticleTypes.Article[]
}

interface State {
    loading: boolean,
    searched: boolean,
    articles: ArticleTypes.Article[],
    suggested: ArticleTypes.Article[],
    top: ArticleTypes.Article[],
    filteredArticles: ArticleTypes.Article[],
    weekIndex: number,
    availability: ArticleTypes.Availability[],
    week: number,
    weeks: Item[],
    keyword: string,
    baseMaterials: ArticleTypes.BaseMaterials[]
}

interface Item {
    id: number,
    label: string
}

class Search extends React.Component<Props, State> {

    static createWeeks = (weeks: number[]) => {
        return weeks.map((week: number) => {
            return {
                label: 'week ' + week,
                id: week
            }
        })
    }

    static getWeekIndex = ( availability: ArticleTypes.Availability[], week: number ) =>
         availability.findIndex((item: ArticleTypes.Availability) => item.week === week)

    static getDerivedStateFromProps ( nextProps: any ) {
        if (nextProps.data && nextProps.data.articles) {

            const firstWeek = nextProps.data.weeks[0]

            const cashedSearch: any = localStorage.getItem(STORAGE_KEYS.SEARCH)

            if (cashedSearch) {
                return JSON.parse(cashedSearch)
            } else {
                return {
                    articles: nextProps.data.articles,
                    suggested: nextProps.data.suggested,
                    top: nextProps.data.top,
                    filteredArticles: nextProps.data.suggested.length > 0 ?
                        nextProps.data.suggested : nextProps.data.top,
                    loading: false,
                    searched: false,
                    week: moment().isoWeek(),
                    weeks: Search.createWeeks(nextProps.data.weeks),
                    availability: nextProps.data.articles.length ? nextProps.data.articles[0].availability : [],
                    keyword: '',
                    weekIndex: nextProps.data.articles.length ?
                        Search.getWeekIndex(nextProps.data.articles[0].availability, firstWeek)  : 0
                }
            }
        } else {
            return null
        }
    }

    constructor(props: Props) {
        super(props)
        this.state = {
            loading: true,
            searched: false,
            weekIndex: 0,
            articles: [],
            suggested: [],
            top: [],
            filteredArticles: [],
            week: 1,
            weeks: [],
            availability: [],
            keyword: '',
            baseMaterials: ['Seed', 'Cutting']
        }
    }

    public componentDidMount() {
        Gtm.pushPageType(PAGE_TYPES.SEARCH)
    }

    public shouldComponentUpdate(nextProps: Props, nextState: State) {
        const cashedSearch: any = localStorage.getItem(STORAGE_KEYS.SEARCH)
        return cashedSearch !== JSON.stringify(nextState)
    }

    public syncStateStorage() {
        global.setTimeout(() => localStorage.setItem(STORAGE_KEYS.SEARCH, JSON.stringify(this.state)), 100)
    }

    public handleWeekUpdate = ( week: number ) => {
        const { keyword, baseMaterials, availability } = this.state

        const filteredArticlesByWeek =
            this.getFilteredArticles(keyword, baseMaterials, Search.getWeekIndex(availability, week))

        this.setState({
            week: week,
            weekIndex: Search.getWeekIndex(this.state.availability, week),
            filteredArticles: filteredArticlesByWeek
        })

        this.syncStateStorage()
    }

    public handleSearchByKeyword = ( keyword: string, baseMaterials: ArticleTypes.BaseMaterials[] ) => {
        this.setState({
            keyword: keyword,
            searched: true,
            baseMaterials: baseMaterials,
            filteredArticles: this.getFilteredArticles(keyword, baseMaterials, this.state.weekIndex)
        })

        this.syncStateStorage()
    }

    public getFilteredArticles = (keyword: string, baseMaterials: ArticleTypes.BaseMaterials[], weekIndex: number) => {
        const { articles } = this.state
        return articles.filter( (obj: any) => (
            (obj.name.toLowerCase().includes(keyword ? keyword.toLowerCase() : '') ||
            obj.productGroupName &&
                (obj.productGroupName.toLowerCase().includes(keyword ? keyword.toLowerCase() : '')))  &&
            baseMaterials.indexOf(obj.baseMaterialName) > -1 && obj.availability[weekIndex].quantity !== 0
        ))
    }

    public render() {

        const { loading, searched, week, weeks, suggested, filteredArticles, weekIndex } = this.state
        const landingTitle = suggested.length > 0 ? 'Suggestions' : 'Top products'

        return (
            <React.Fragment>
                <SearchContainer
                    value={this.state.keyword}
                    placeholder="Search"
                    onInput={this.handleSearchByKeyword}
                />
                <div className="u-margin-top--md u-margin-bottom--xs">
                    <ScrollerSelect
                        onUpdate={this.handleWeekUpdate}
                        activeId={week}
                        listItems={weeks}
                    />
                </div>
                <h1 className="u-margin-bottom--md u-margin-left--md">
                    {searched ? 'Results' : landingTitle}
                </h1>
                {loading ?
                    <Loader /> :
                    <VarietiesTable
                        items={filteredArticles}
                        weekIndex={weekIndex}
                    />
                }
            </ React.Fragment>
        )
    }
}

export default hasData({
    url: API.host + API.endpoints.surplus + '?companyId=10',
    cache: true
})(Search)



// WEBPACK FOOTER //
// ./src/containers/Search/index.tsx